import ResourceBase from './../shared/resource-base';
import FeatureFlag from '../featureflags/featureflag-model';
import { deserialize, custom } from 'serializr';
import ModelSchemas from './../shared/model-schema';
import _ from 'lodash';

export default class FeatureFlagResource extends ResourceBase {
    constructor() {
        super(FeatureFlag);
        this.featureFlagSchema = ModelSchemas.createCoordinatorSchema(FeatureFlag);
    }

    getFeatures(token) {
        const payload = { filter: { order: 'name ASC' } };
        // if (!includeDisabled) {
        //     payload.filter['where'] = {disabled: false}
        // }
        return new Promise((resolve, reject) => {
            this.find(token)
                .then(featureFlags => {
                    let featureFlagModels = [];
                    featureFlags.forEach(featureFlagJSON => {
                        featureFlagModels.push(deserialize(this.featureFlagSchema, featureFlagJSON));
                    });
                    resolve(featureFlagModels);
                })
                .catch(reject);
        });
    }
}



// WEBPACK FOOTER //
// ./src/featureflags/featureflag-resource.js